{
  "title": "Proporcionar verificación de ID",
  "client": "Cliente",
  "relationshipTo": "Relación con {{whom}} (miembro principal)",
  "continue": "Continuar",
  "updated": "Se ha actualizado el miembro del hogar {{memberName}}.",
  "save": "Guardar",
  "documentType": "Tipo de documento",
  "methodOfIDVerification": "Método de verificación de ID",
  "informationSource": "Origen de la información",
  "informationType": "Tipo de información",
  "documentID": "Número de referencia del documento",
  "documentIDSingle": "ID del documento",
  "userName": "Nombre en la ID",
  "secondaryUserName": "Nombre en la ID",
  "informationSourceSingle": "Jurisdicción emisora del documento",
  "verifiedDate": "Fecha de verificación",
  "expiryDate": "Fecha de vencimiento",
  "nextDocument": "Siguiente documento",
  "saveDoc1": "Guardar documento 1 de 2",
  "saveDoc2": "Guardar documento 2 de 2",
  "firstPageStepSingleMethod": "PASO 1 de 1",
  "firstPageStepDualMethod": "PASO 1 de 2",
  "secondPageStepDualMethod": "PASO 2 de 2",
  "summaryTitle": "Proporcionar verificación de ID",
  "documentName": "Nombre del documento",
  "documentsUploaded": "2 documentos cargados",
  "documentUploaded": "1 documento cargado",
  "noDocumentUploaded": "Ningún documento cargado",
  "noOptionsText": "Introduzca nueva jurisdicción"
}
